// src/components/broadcast-tool.jsx — PREMIUM STYLIST BROADCAST SYSTEM
import React, { useState, useEffect } from 'react';
import { collection, addDoc, serverTimestamp, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { db, auth } from '../firebase';

const GOLD = '#B8860B';
const NAVY = '#001F3F';

export default function BroadcastTool({ clientCount, onClose }) {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isEligible, setIsEligible] = useState({ allowed: true, reason: '' });

  useEffect(() => {
    checkEligibility();
  }, []);

  const checkEligibility = async () => {
    const stylistId = auth.currentUser.uid;
    const now = new Date();
    const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    const oneYearAgo = new Date(now.getFullYear(), 0, 1); // Reset Jan 1st

    const q = query(
        collection(db, 'broadcast_logs'), 
        where('stylistId', '==', stylistId),
        orderBy('sentAt', 'desc')
    );

    const snap = await getDocs(q);
    const logs = snap.docs.map(d => d.data().sentAt?.toDate());

    const recentInWeek = logs.filter(date => date > oneWeekAgo);
    const recentInYear = logs.filter(date => date > oneYearAgo);

    if (recentInWeek.length >= 1) {
        setIsEligible({ allowed: false, reason: 'Limited to 1 broadcast per week.' });
    } else if (recentInYear.length >= 10) {
        setIsEligible({ allowed: false, reason: 'Annual limit of 10 broadcasts reached.' });
    }
  };

  const calculateCost = (count) => {
    if (count <= 50) return 5000;
    return 5000 + (Math.ceil((count - 50) / 10) * 1000);
  };

  const cost = calculateCost(clientCount);

  const handleSubmit = async () => {
    if (!isEligible.allowed) return alert(isEligible.reason);
    if (message.length > 140) return alert("Max 140 characters.");
    
    setLoading(true);
    try {
      await addDoc(collection(db, 'broadcast_requests'), {
        stylistId: auth.currentUser.uid,
        stylistName: auth.currentUser.displayName,
        message,
        targetCount: clientCount,
        cost,
        status: 'pending_admin_approval',
        createdAt: serverTimestamp(),
      });
      alert("Request submitted. Awaiting Admin review and payment confirmation.");
      onClose();
    } catch (err) {
      alert("Error submitting request.");
    } finally { setLoading(false); }
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <h2 style={{ color: GOLD, margin: '0 0 10px' }}>Premium Broadcast</h2>
        {!isEligible.allowed ? (
            <p style={{ color: '#ff6b6b', fontSize: '0.9rem' }}>⚠️ {isEligible.reason}</p>
        ) : (
            <p style={{ fontSize: '0.8rem', opacity: 0.7 }}>Reach {clientCount} clients directly.</p>
        )}
        
        <div style={infoBox}>
          <p><strong>Fee:</strong> ₦{cost.toLocaleString()}</p>
          <p style={{ fontSize: '0.7rem' }}>Tracking ID: {auth.currentUser.uid.slice(0,8)}</p>
        </div>

        <textarea 
          disabled={!isEligible.allowed}
          maxLength={140}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Enter your 140-char message..."
          style={inputStyle}
        />
        
        <button 
            onClick={handleSubmit} 
            disabled={loading || !message || !isEligible.allowed} 
            style={{...sendBtn, opacity: isEligible.allowed ? 1 : 0.5}}
        >
          {loading ? 'Processing...' : `Request Broadcast`}
        </button>
        <button onClick={onClose} style={cancelBtn}>Close</button>
      </div>
    </div>
  );
}

const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', display: 'grid', placeItems: 'center', zIndex: 10000 };
const modal = { background: NAVY, padding: '2rem', borderRadius: '24px', border: `2px solid ${GOLD}`, width: '90%', maxWidth: '400px' };
const infoBox = { background: 'rgba(255,255,255,0.05)', padding: '10px', borderRadius: '12px', margin: '15px 0' };
const inputStyle = { width: '100%', height: '100px', background: '#000', color: 'white', border: `1px solid ${GOLD}`, borderRadius: '12px', padding: '10px', boxSizing: 'border-box' };
const sendBtn = { width: '100%', padding: '12px', background: GOLD, border: 'none', borderRadius: '50px', fontWeight: 'bold', marginTop: '15px', cursor: 'pointer' };
const cancelBtn = { width: '100%', padding: '12px', background: 'transparent', color: 'white', border: 'none', cursor: 'pointer' };
                              
